import React from 'react';
import {ISearchFilterContext, ISearchFilterSet} from '../Types/ISearchFilter';

const searchFilterContext: React.Context<ISearchFilterContext> = React.createContext({
    activeFilters: null,
    availableFilters: null,
    setActiveFilters: (filters: ISearchFilterSet | null) => {
        return filters;
    },
    searchParameters: null
} as ISearchFilterContext);

export default searchFilterContext;
